export default __webpack_public_path__ + "static/media/body.cfacda6f.jpg";